import { action } from 'typesafe-actions';

const entity = 'dex_trades';
const ACTION_SET_TRADES_WALLET = `${entity}/ACTION_SET_TRADES_WALLET`;
const ACTION_SET_DRAW_MARKS = `${entity}/ACTION_SET_DRAW_MARKS`;
const ACTION_SET_REMOVE_MARKS = `${entity}/ACTION_SET_REMOVE_MARKS`;

const actionSetTradesWallet = (address: string | null) =>
  action(ACTION_SET_TRADES_WALLET, address);

const actionSetDrawMarks = (callback: () => void) =>
  action(ACTION_SET_DRAW_MARKS, callback);

const actionSetRemoveMarks = (callback: () => void) =>
  action(ACTION_SET_REMOVE_MARKS, callback);

export {
  ACTION_SET_TRADES_WALLET,
  ACTION_SET_DRAW_MARKS,
  ACTION_SET_REMOVE_MARKS,
  actionSetTradesWallet,
  actionSetDrawMarks,
  actionSetRemoveMarks,
};
